import templateStr from 'text!./account-billing.html';
import 'portalConfig';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            accountBillingSummary: '=',
            accountBillingData: '=',
            accountLoaded: '=',
            accountNumber: '@'
        },
        controller: ['$scope', '$state', ($scope, $state) => {
            if ($scope.accountBillingSummary) {
                $scope.displayAddressArray = $scope.accountBillingSummary.primaryPayer.address.split(', ');
            }
            $scope.makeAPayment = (accountNumber) => {
                const payMode = 'billed';
                $state.go('gatewaybilling-invoice-payment', {accountNumber, payMode});
            };
        }]
    };
}];
